import React from 'react';
import PropTypes from 'prop-types';

export default function CartAmountToggle({ 
  quantity, 
  setQuantity, 
  stock, 
  price,
  discount = 0 // New discount prop (as percentage)
}) {
  // Calculate discounted price
  const getDiscountedPrice = () => {
    const discountAmount = price * (discount / 100);
    const finalPrice = price - discountAmount;
    return finalPrice;
  };

  // Calculate total with discount
  const calculateTotal = () => {
    const finalPrice = getDiscountedPrice();
    return (quantity * finalPrice).toFixed(2);
  };

  const decrease = () => {
    quantity > 1 && setQuantity(quantity - 1);
  };

  const increase = () => {
    quantity < stock && setQuantity(quantity + 1);
  };

  return (
    <div className="cs_product_controls">
      <div className="cs_quantity_wrap">
        <button 
          type="button" 
          className="cs_quantity_btn" 
          onClick={decrease}
          disabled={quantity <= 1}
        >
          -
        </button>
        <input 
          type="number" 
          className="cs_quantity_input" 
          value={quantity}
          readOnly 
        />
        <button 
          type="button" 
          className="cs_quantity_btn" 
          onClick={increase}
          disabled={quantity >= stock}
        >
          +
        </button>
      </div>
      <div className="cs_price_details">
        <div className="cs_price_display">
          Total: ${calculateTotal()}
        </div>
        {discount > 0 && (
          <div className="cs_discount_info">
            <span className="cs_original_price">${(quantity * price).toFixed(2)}</span>
            <span className="cs_discount_badge">-{discount}%</span>
          </div>
        )}
      </div>
    </div>
  );
}

CartAmountToggle.propTypes = {
  quantity: PropTypes.number.isRequired,
  setQuantity: PropTypes.func.isRequired,
  stock: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  discount: PropTypes.number
};